var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"seller-message"},[_c('div',{staticClass:"tw-block tw-break-all tw-rounded tw-whitespace-pre-wrap  seller-message__message"},[_c('span',{staticClass:"seller-message__message__readmore"},[_vm._v(_vm._s(_vm.message))])])])}
var staticRenderFns = []

export { render, staticRenderFns }